import { render, staticRenderFns } from "./Especialidad.vue?vue&type=template&id=083ef9a5&scoped=true&"
import script from "./Especialidad.vue?vue&type=script&lang=js&"
export * from "./Especialidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083ef9a5",
  null
  
)

export default component.exports